import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpHelper } from '../helpers/http.helper';
import { omit } from 'lodash';
import { TransferBaseModel } from './transfer-base.model';

export abstract class ApiBaseService {
    protected get basePath(): string {
        if (!this.baseUrl || this.baseUrl.length === 0) {
            return this.apiBasePath;
        }
        return `${this.apiBasePath}${this.baseUrl}`;
    }
    constructor(
        protected httpClient: HttpClient,
        protected baseUrl: string = null,
        protected apiBasePath: string = environment.defaultApiBasePath
    ) {}
}

export class CrudBaseService<
    T extends TransferBaseModel
> extends ApiBaseService {
    constructor(
        protected baseUrl: string,
        protected httpClient: HttpClient,
        protected apiBasePath: string = environment.defaultApiBasePath
    ) {
        super(httpClient, baseUrl, apiBasePath);
    }

    get(id: string): Observable<T> {
        return this.httpClient
            .get<T>(`${this.basePath}/${id}`)
            .pipe(map((res: any) => res && res.data));
    }

    filter(filterParams: any): Observable<T[]> {
        return this.httpClient
            .get<T[]>(this.basePath, {
                params: HttpHelper.objectToHttpParams({ ...filterParams }),
            })
            .pipe(map((res: any) => res && res.data));
    }

    create(model: T): Observable<any> {
        return this.httpClient.post(this.basePath, {
            data: omit(model, ['id']),
        });
    }

    update(id: string, model: T): Observable<any> {
        return this.httpClient.patch(`${this.basePath}/${id}`, {
            data: omit(model, ['id']),
        });
    }

    delete(id: string): Observable<any> {
        return this.httpClient.delete(`${this.basePath}/${id}`);
    }
}
